import { LoginErrorsType } from '@ibk/shared-types';
export function mapLoginErrorToMessage(errorValue, t) {
    switch (errorValue) {
        case LoginErrorsType.INVALID_CREDENTIALS:
            return t('auth.error.invalid-credentials');
        case LoginErrorsType.FEATURE_NOT_ENABLED:
            return t('auth.error.feature-not-enabled');
        case LoginErrorsType.CREDENTIAL_ROLE_INVALID:
            return t('auth.error.credential-role-invalid');
        case LoginErrorsType.GENERIC:
            return t('auth.error.generic');
        default:
            return t('auth.error.generic');
    }
}
